module.exports = __webpack_public_path__ + "img/pill-grid-8x3-1440w.7e94e8aa.jpg";